import { __assign } from "tslib";
import { styled, Tabs as MuiTabs } from '@mui/material';
import { alpha } from "@mui/system";
export var StyledTabs = styled(MuiTabs, {
    shouldForwardProp: function (prop) { return !['size', 'indicatorPosition', 'isBordered', 'isFilled', 'scrollButtonPosition'].includes(String(prop)); },
})(function (_a) {
    var _b;
    var theme = _a.theme, isBordered = _a.isBordered, isFilled = _a.isFilled, indicatorPosition = _a.indicatorPosition, size = _a.size, variant = _a.variant, scrollButtonPosition = _a.scrollButtonPosition;
    return (__assign(__assign({ '.MuiTabs-indicator': __assign(__assign({}, (indicatorPosition === 'top' && {
            top: 0
        })), (isFilled && {
            height: 0
        })) }, (scrollButtonPosition === 'right' && {
        '.MuiTabScrollButton-root': {
            opacity: 1,
            '&.MuiTabScrollButton-horizontal': {
                order: 1,
                width: 38,
                border: "1px solid ".concat(theme.palette.divider),
                '&:first-of-type': {
                    borderRight: 0,
                    boxShadow: "-2px 0 2px 0 rgba(0, 0, 0, 0.08)",
                },
                '&:last-of-type': {
                    borderLeft: 0,
                },
            },
            '&.Mui-disabled': {
                opacity: 1,
                svg: {
                    opacity: 0.48,
                },
            },
        }
    })), { '.MuiTab-root': __assign(__assign(__assign(__assign(__assign(__assign((_b = { minHeight: 0, paddingLeft: theme.spacing(2.5), paddingRight: theme.spacing(2.5), textTransform: "none", fontSize: theme.typography.body1.fontSize }, _b[theme.breakpoints.down('sm')] = {
            fontSize: "0.813rem", //13
        }, _b), (variant === 'fullWidth' && {
            flexGrow: 1
        })), (isBordered && {
            border: "1px solid ".concat(theme.palette.greySecondary[100]),
            '&.MuiButtonBase-root': {
                '~ .MuiButtonBase-root': {
                    marginLeft: "-1px",
                },
            },
            '&:hover': {
                backgroundColor: alpha(theme.palette.greySecondary[800], 0.08),
            },
            '&.Mui-selected': {
                borderBottomColor: "transparent",
                color: theme.palette.greySecondary[800],
                backgroundColor: theme.palette.common.white,
                '&:hover': {
                    backgroundColor: alpha(theme.palette.greySecondary[800], 0.08),
                },
            },
        })), (isFilled && {
            border: "1px solid ".concat(theme.palette.greySecondary[100]),
            '&.MuiButtonBase-root': {
                '~ .MuiButtonBase-root': {
                    marginLeft: "-1px",
                },
            },
            '&.Mui-selected': {
                backgroundColor: theme.palette.greySecondary.main,
                color: theme.palette.greySecondary.contrastText,
            },
        })), (size === 'small' && {
            minHeight: 32,
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: theme.spacing(1),
            paddingRight: theme.spacing(1), // 8,
        })), (size === 'medium' && {
            minHeight: 44,
        })), (size === 'large' && {
            minHeight: 60,
        })) }));
});
//
// export const StyledTabs = styled(MuiTabs, {
//   shouldForwardProp: prop => !['size', 'variant', 'indicatorPosition', 'isBordered', 'scrollButtonPosition' ].includes(String(prop)),
// })<TabsProps>(({ theme, size, variant, indicatorPosition, isBordered, scrollButtonPosition }) => ({
//
//   // '.MuiTabs-indicator': {
//   //   ...(indicatorPosition === 'top' && {
//   //     top: 0
//   //   }),
//   // },
//   //
//   // ...(scrollButtonPosition === 'right' && {
//   //   outline: `1px solid red`
//   // }),
//   // '.MuiTab-root' : {
//   //   minHeight: 0,
//   //   paddingLeft: 20,
//   //   paddingRight: 20,
//   //   textTransform: `none`,
//   //
//   //   ...(variant === 'fullWidth' && {
//   //       flexGrow: 1
//   //   }),
//   //   ...(variant === undefined && {
//   //
//   //   }),
//   //   ...(isBordered && {
//   //       border: `1px solid ${theme.palette.greySecondary[100]}`,
//   //
//   //       '&.MuiButtonBase-root': {
//   //         '~ .MuiButtonBase-root': {
//   //           marginLeft: `-1px`,
//   //         },
//   //       },
//   //       '&:hover': {
//   //         backgroundColor: alpha(theme.palette.greySecondary[800], 0.08),
//   //       },
//   //       '&.Mui-selected': {
//   //         borderBottomColor: `transparent`,
//   //         color: theme.palette.greySecondary[800],
//   //         backgroundColor: theme.palette.common.white,
//   //         '&:hover': {
//   //           backgroundColor: alpha(theme.palette.greySecondary[800], 0.08),
//   //         },
//   //       },
//   //   }),
//
//     // ...(size === 'small' && {
//     //   minHeight: 32,
//     //   paddingTop: 0,
//     //   paddingBottom: 0,
//     //   paddingLeft: 8,
//     //   paddingRight: 8,
//     // }),
//     // ...(size === 'medium' && {
//     //   minHeight: 44,
//     // }),
//     // ...(size === 'large' && {
//     //   minHeight: 60,
//     // }),
//   // },
//
//
// }));
//# sourceMappingURL=styled.js.map